import React, { useContext } from "react";
import { observer } from "mobx-react";
import { EventContext } from "@gp/components";

import classNames from "classnames";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import CashoutIndicator from "@features/my-bets/shared/cashout/CashoutIndicator";
import CashoutButtonCore from "@features/my-bets/shared/cashout/CashoutButtonCore";

export default observer(function StartCashoutProcessButton(props: {
	store: CashoutStore;
}) {
	const bet = useContext(MyBetsBetContext);
	const event = useContext(EventContext);

	if (bet.cType == undefined) {
		console.error("cType can not be null");
		return null;
	}
	if (bet.displayedAmount == undefined) {
		console.error("displayedAmount can not be null");
		return null;
	}

	const cType = bet.cType;
	const displayedAmount = bet.displayedAmount;

	const buttonClasses = classNames(
		"card--bet__btn card--bet__btn--cash btn btn--xsml btn--cashout btn--icon",
		{
			inc: bet.indicator > 0,
			dec: bet.indicator < 0,
		}
	);

	return (
		<>
			<button
				type="button"
				disabled={props.store.isCashoutFormSubmitting}
				onClick={() =>
					props.store.openEventCashoutModal(
						{
							userId: bet.userId || "",
							id: bet.id,
							calculatedCashoutAmount:
								bet.calculatedCashoutAmount,
							cType: cType,
							isChangeAccepted: false,
							isLive: bet.isLive,
							displayedAmount: displayedAmount,
							liveBetSlipCountdown: bet.liveBetSlipCountdown,
						},
						event.id
					)
				}
				className={buttonClasses}
			>
				<CashoutIndicator />
				<CashoutButtonCore />
			</button>
		</>
	);
});
